import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const LandingPageHeadline = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14915)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#FFEDBF"
          />
          <path
            d="M176.954 41.8521V114.831C176.954 117.251 175.993 119.571 174.282 121.282C172.571 122.993 170.251 123.954 167.831 123.954H81.1686C78.7492 123.954 76.4289 122.993 74.7181 121.282C73.0073 119.571 72.0462 117.251 72.0462 114.831V41.8521H176.954Z"
            fill="#66E1FF"
          />
          <path
            d="M72.0462 41.8521V114.831C72.0462 117.251 73.0073 119.571 74.7181 121.282C76.4289 122.993 78.7492 123.954 81.1686 123.954H85.7298L167.831 41.8521H72.0462Z"
            fill="#C2F3FF"
          />
          <path
            d="M176.954 41.8524H72.0462V28.1688C72.0462 25.7494 73.0073 23.4291 74.7181 21.7183C76.4289 20.0075 78.7492 19.0464 81.1686 19.0464H167.831C170.251 19.0464 172.571 20.0075 174.282 21.7183C175.993 23.4291 176.954 25.7494 176.954 28.1688V41.8524Z"
            fill="white"
          />
          <path
            d="M167.831 19.0464H81.1686C78.7492 19.0464 76.4289 20.0075 74.7181 21.7183C73.0073 23.4291 72.0462 25.7494 72.0462 28.1688V114.832C72.0462 117.251 73.0073 119.571 74.7181 121.282C76.4289 122.993 78.7492 123.954 81.1686 123.954H167.831C170.251 123.954 172.571 122.993 174.282 121.282C175.993 119.571 176.954 117.251 176.954 114.832V28.1688C176.954 25.7494 175.993 23.4291 174.282 21.7183C172.571 20.0075 170.251 19.0464 167.831 19.0464Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M72.0462 41.8521H176.954"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M88.0104 31.5897C87.708 31.5897 87.418 31.4695 87.2041 31.2557C86.9903 31.0418 86.8701 30.7518 86.8701 30.4494C86.8701 30.147 86.9903 29.8569 87.2041 29.6431C87.418 29.4292 87.708 29.3091 88.0104 29.3091"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M88.0104 31.5897C88.3128 31.5897 88.6029 31.4695 88.8167 31.2557C89.0306 31.0418 89.1507 30.7518 89.1507 30.4494C89.1507 30.147 89.0306 29.8569 88.8167 29.6431C88.6029 29.4292 88.3128 29.3091 88.0104 29.3091"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M59 50C59 49.4477 59.4477 49 60 49H132C132.552 49 133 49.4477 133 50V66.7001C133 67.2523 132.552 67.7001 132 67.7001H60C59.4477 67.7001 59 67.2523 59 66.7001V50Z"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="2"
          />
          <path
            d="M63.393 55.354V54.3735C63.393 54.1134 63.4963 53.864 63.6802 53.6801C63.8641 53.4962 64.1135 53.3929 64.3735 53.3929H71.2372C71.4973 53.3929 71.7467 53.4962 71.9305 53.6801C72.1144 53.864 72.2177 54.1134 72.2177 54.3735V55.354"
            stroke="#1E1E1E"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M67.8049 53.3928V62.2176"
            stroke="#1E1E1E"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M65.8446 62.2177H69.7667"
            stroke="#1E1E1E"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M74.8872 62.7083H83.603"
            stroke="#1E1E1E"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M104.961 74.208H88.4814C88.0444 74.208 87.6252 74.3816 87.3162 74.6907C87.0071 74.9997 86.8335 75.4189 86.8335 75.8559V89.0393C86.8335 89.4763 87.0071 89.8955 87.3162 90.2045C87.6252 90.5136 88.0444 90.6872 88.4814 90.6872H104.961C105.398 90.6872 105.817 90.5136 106.126 90.2045C106.435 89.8955 106.608 89.4763 106.608 89.0393V75.8559C106.608 75.4189 106.435 74.9997 106.126 74.6907C105.817 74.3816 105.398 74.208 104.961 74.208Z"
            fill="#FFEF5E"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.3614 74.6456L106.082 90.2481"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.3614 90.2481L106.082 74.6456"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M104.961 97.75H88.4814C88.0444 97.75 87.6252 97.9236 87.3162 98.2327C87.0071 98.5417 86.8335 98.9609 86.8335 99.3979V112.581C86.8335 113.018 87.0071 113.437 87.3162 113.747C87.6252 114.056 88.0444 114.229 88.4814 114.229H104.961C105.398 114.229 105.817 114.056 106.126 113.747C106.435 113.437 106.608 113.018 106.608 112.581V99.3979C106.608 98.9609 106.435 98.5417 106.126 98.2327C105.817 97.9236 105.398 97.75 104.961 97.75Z"
            fill="#FFEF5E"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.3614 98.1876L106.082 113.79"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.3614 113.79L106.082 98.1876"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.805 76.5625H163.417"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.805 85.6846H154"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.805 94.8076H158.635"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.805 103.562H149.734"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.805 111.875H137.963"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M101.694 31.5897C101.392 31.5897 101.102 31.4695 100.888 31.2557C100.674 31.0418 100.554 30.7518 100.554 30.4494C100.554 30.147 100.674 29.8569 100.888 29.6431C101.102 29.4292 101.392 29.3091 101.694 29.3091"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M101.694 31.5897C101.996 31.5897 102.286 31.4695 102.5 31.2557C102.714 31.0418 102.834 30.7518 102.834 30.4494C102.834 30.147 102.714 29.8569 102.5 29.6431C102.286 29.4292 101.996 29.3091 101.694 29.3091"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M115.378 31.5897C115.075 31.5897 114.785 31.4695 114.571 31.2557C114.357 31.0418 114.237 30.7518 114.237 30.4494C114.237 30.147 114.357 29.8569 114.571 29.6431C114.785 29.4292 115.075 29.3091 115.378 29.3091"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M115.378 31.5897C115.68 31.5897 115.97 31.4695 116.184 31.2557C116.398 31.0418 116.518 30.7518 116.518 30.4494C116.518 30.147 116.398 29.8569 116.184 29.6431C115.97 29.4292 115.68 29.3091 115.378 29.3091"
            stroke="#191919"
            strokeWidth="1.5"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14915">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
